"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requireEnv = void 0;
const collections_1 = require("./collections");
function requireEnv(...names) {
    const values = names.reduce((acc, name) => {
        var _a;
        const value = (_a = process.env[name]) === null || _a === void 0 ? void 0 : _a.trim();
        if (!value) {
            throw new Error(`Missing env variable ${name}`);
        }
        return (0, collections_1.set)(acc, name, value);
    }, {});
    return (names.length === 1 ? values[names[0]] : values);
}
exports.requireEnv = requireEnv;
